export default __webpack_public_path__ + "static/media/undraw_quiz_nlyh.7d25c38f.svg";